
import "@/styles/giftCodeRedemption.scss";
import { isMobile } from "@/utils/is";
import { Form, FormItem, Input } from "apower-ui";
import { codesActivate } from "@/api/sharefission";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            new Vue({
  components: {
    ApForm: Form,
    ApFormItem: FormItem,
    ApInput: Input,
  },
  data() {
    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        // callback(new Error(this.$t("Account.001213")));
      } else if (value.length < 6 || value.length > 20) {
        // callback(new Error(this.$t("Account.002145")));
      } else {
        callback();
      }
    };
    return {
      isMobile: isMobile,
      showPic: false,
      vipStatus: "",
      form: {
        userId: "",
        vipcode: "",
      },
      codeError: false,
      uidError: false,
      errStatus: 1,
      rules: {
        account: [{ validator: passwordValidator, trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    showPicM() {
      if (isMobile) {
        this.showPic = true;
      }
    },
    onSubmit() {
      let tempcode = this.form.vipcode.replace(/(^\s*)|(\s*$)/g, "");
      let flag = 0;
      if (!/^\d{1,8}$/.test(this.form.userId)) {
        this.uidError = true;
        flag = 1;
      } else {
        this.uidError = false;
      }
      if (
        !/^[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/.test(
          tempcode
        )
      ) {
        this.codeError = true;
        flag = 1;
      } else {
        this.codeError = false;
      }
      if (flag) {
        return;
      }
      this.vipStatus = "loading";
      const postData = {
        code: tempcode,
        user_id: this.form.userId,
      };
      codesActivate(postData)
        .then(() => {
          this.vipStatus = "success";
        })
        .catch((err) => {
          console.log(err);
          this.vipStatus = "fail";
          this.errStatus = 1;
          if (err.status === -98) {
            this.errStatus = 2;
          }
        })
        .finally(() => {
          // this.loading = false;
        });
    },
  },
}).$mount("#app");

          })
        